<template>
  <div>
    <div v-if="isTodo" style="width:100%;height:40px;"></div>
    <div v-if="statRequestParams!=null">
      <el-row :gutter="20">
        <el-col :span="24">
          <Todo ref="todo"></Todo>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <Dashboard ref="dashboard"></Dashboard>
        </el-col>
        <el-col :span="12">
          <OverduePie ref="overduePie"></OverduePie>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <OverdueLine ref="overdueLine"></OverdueLine>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <Completed ref="completed"></Completed>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Dashboard from "./dashboard";
import Todo from "./todo";
import OverduePie from "./overdue-pie";
import OverdueLine from "./overdue-line";
import Completed from "./completed";

import { getAcceptTaskServerCenters } from "@/api/modules/basicData/task";

import { getToken } from "@/util/auth";
const cookieUser = getToken();

import { mapState } from "vuex";

export default {
  name: "TaskStatView",
  components: {
    Dashboard,
    Todo,
    OverduePie,
    OverdueLine,
    Completed
  },
  data() {
    return {
      statRequestParams: {},
      isEmpty: false
    };
  },
  computed: {
    ...mapState({
      taskParas: state => state.task.taskParas,
      taskTag: state => state.task.tagItem
    })
  },
  props: {
    isTodo: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    taskParas(newValue, oldValue) {
      console.log("taskParasChange", newValue);
      this.refresh(0);
    },
    taskTag(newValue, oldValue) {
      console.log("taskTagChange", newValue);
      if (this.taskTag.TEMPTYPE == 1) {
        // this.refresh(1);
      }
    }
  },
  methods: {
    fetchStat(userId, serverCenterId) {
      if (this.isTodo) {
        // 待办事项的定制处理
        this.statRequestParams = {
          UserId: userId,
          TaskIds: "",
          Paras: {},
          ServerCenterId: serverCenterId
        };
        this.refreshWithParams();
        return;
      }
      let currentTemplate = this.$store.state.task.tagItem;
      if (!currentTemplate) {
        return;
      }
      let taskIds = "";
      let paras = {};
      if (currentTemplate.TEMPTYPE == 0) {
        taskIds = "";
        // paras = JSON.parse(currentTemplate.CONTENT);
        paras = this.taskParas;
        paras["CurrentUserId"] = userId;
      } else if (currentTemplate.TEMPTYPE == 1) {
        taskIds = currentTemplate.CONTENT;
        paras = {};
      }
      if (!taskIds && Object.keys(paras).length == 0) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      this.statRequestParams = {
        UserId: "",
        TaskIds: taskIds,
        Paras: paras,
        ServerCenterId: serverCenterId
      };
      this.refreshWithParams();
    },
    refreshWithParams() {
      this.$refs.todo.refresh(this.statRequestParams);
      this.$refs.dashboard.refresh(this.statRequestParams);
      this.$refs.overduePie.refresh(this.statRequestParams);
      this.$refs.overdueLine.refresh(this.statRequestParams);
      this.$refs.completed.refresh(this.statRequestParams);
    },
    refresh(type) {
      if (this.isTodo) {
        // 待办事项不用刷新统计视图
        return;
      }
      if (type == 0) {
        //传参数
        let content = this.taskParas;
        this.statRequestParams.TaskIds = "";
        this.statRequestParams.Paras = content;
        this.statRequestParams.Paras["CurrentUserId"] = cookieUser.userId;
      } else if (type == 1) {
        //传ids
        let content = this.taskTag.CONTENT;
        this.statRequestParams.TaskIds = content;
        this.statRequestParams.Paras = {};
      }
      if (
        !this.statRequestParams.TaskIds &&
        Object.keys(this.statRequestParams.Paras).length == 0
      ) {
        this.isEmpty = true;
      } else {
        this.isEmpty = false;
      }
      this.$refs.todo.refresh(this.statRequestParams);
      this.$refs.dashboard.refresh(this.statRequestParams);
      this.$refs.overduePie.refresh(this.statRequestParams);
      this.$refs.overdueLine.refresh(this.statRequestParams);
      this.$refs.completed.refresh(this.statRequestParams);
    }
  },
  mounted() {
    // 获取serverCenterId后，初始数据
    let serverCenterId = JSON.parse(
      localStorage.getItem("ServerCenterMember") || "[]"
    ).join(",");
    this.fetchStat(cookieUser.userId, serverCenterId);
    console.log(serverCenterId);
  }
};
</script>

<style lang="less" scoped>
* {
  font-size: 14px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
